import React, { useMemo } from "react"
import { useRouter } from "next/router"
import Image from "next/image"
import { AdvertisementResponse } from "types/Advertisements"
import Carousel from "components/Carousel/Carousel"

interface HomeAdsSliderProps {
    ads: AdvertisementResponse["payload"]
    currentIndex: number
    onSlideChange: (index: number) => void
}

const HomeAdsSlider = ({ ads, currentIndex, onSlideChange }: HomeAdsSliderProps) => {
    const router = useRouter()

    const advertisementSliders = useMemo(
        () => ads?.filter((ad) => ad.web_view_type === "slider") || [],
        [ads]
    )

    if (!advertisementSliders.length) {
        return (
            <div className="layout w-full lg:mt-22 mt-20 relative rounded-xl lg:max-w-[1230px]">
                <div className="lg:aspect-[16/8] aspect-[11/16] w-full rounded-xl bg-[#F7F6FF] dark:bg-[#33276F] animate-pulse" />
            </div>
        )
    }

    return (
        <div className="layout w-full lg:mt-22 mt-20 relative rounded-xl lg:max-w-[1230px]">
            <Carousel
                items={advertisementSliders}
                autoPlayInterval={5000}
                showArrows={false}
                activeIndex={currentIndex}
                onSlideChange={onSlideChange}
                className="lg:aspect-[16/8] aspect-[11/16] overflow-hidden rounded-xl"
                onSlideClick={(img) => {
                    if (img.type === "single") {
                        router.push(`/events/${img.events[0]}`)
                    }
                }}
                renderSlide={(img, index) => {
                    const mobileUrl = `${process.env.NEXT_PUBLIC_Event_Img_URL}${img?.image || ""}`
                    const desktopUrl = `${process.env.NEXT_PUBLIC_Event_Img_URL}${img.web_image || ""}`
                    const isPriority = index === 0
                    
                    return (
                        <div className={`relative w-full h-full ${img.type === "single" ? "cursor-pointer" : ""}`}>
                            {/* Use picture element with CSS media queries for instant correct image */}
                            <picture className="absolute inset-0">
                                <source media="(max-width: 767px)" srcSet={mobileUrl} />
                                <source media="(min-width: 768px)" srcSet={desktopUrl} />
                                <Image
                                    src={desktopUrl}
                                    alt={img?.ar_description || "Advertisement"}
                                    fill
                                    className="object-cover rounded-xl"
                                    priority={isPriority}
                                    sizes="(max-width: 767px) 100vw, (max-width: 1230px) 90vw, 1230px"
                                />
                            </picture>
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default HomeAdsSlider
